// import { Celular, Token } from 'models/cadastros/validacao/types'
import * as yup from 'yup'
import { pt } from 'yup-locale-pt'

// yup.setLocale(pt)
// export const schemaToken: yup.SchemaOf<Token> = yup.object().shape({
//   codigo: yup.string().required().label('Código')
// })

// export const schemaCelular: yup.SchemaOf<Celular> = yup.object().shape({
//   celular: yup.string().length(11).required().label('Celular')
// })

export const schemaReferencias = yup.array().of(
  yup.object().shape({
    nome: yup.string().required().min(3).max(100).label('Nome'),
    ddd: yup.string().required().min(2).max(3).label('DDD'),
    numero: yup.string().required().min(8).max(9).label('Número'),
    grauReferenciaCrefazId: yup
      .string()
      .transform((value) => (value === null ? '' : value))
      .required()
      .label('Grau de Referência')
  })
)
